module.exports = __webpack_public_path__ + "media/images/default/homepage/news/news_default-c8084bdc06ee710375fdbf6926b30b50.jpeg";